import { useLocale } from "../stores/locale";
import { Button } from "./button";
import { H1 } from "./h1";
import { Modal } from "./modal";

export function Confirm({
  header,
  type = "yes-no",
  loading = false,
  onClose,
  onConfirm,
}: {
  open?: boolean;
  header: string;
  loading?: boolean;
  type?: "yes-no" | "ok";
  onClose: () => void;
  onConfirm: () => void;
}) {
  const t = useLocale((state) => state.locale);

  return (
    <Modal open size="xs" onClose={onClose}>
      <form
        className="flex-1 flex flex-col items-center gap-4"
        onSubmit={(e) => {
          e.preventDefault();
          onConfirm();
        }}
      >
        <H1>{header}</H1>
        <div className="flex-1 flex items-center gap-4">
          <Button
            loading={loading}
            severity={type === "yes-no" ? "primary" : "danger"}
            type="submit"
          >
            {type === "yes-no" ? t.yes : t.ok}
          </Button>
          <Button
            disabled={loading}
            severity="secondary"
            type="button"
            onClick={onClose}
          >
            {type === "yes-no" ? t.no : t.cancel}
          </Button>
        </div>
      </form>
    </Modal>
  );
}
